var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { PayloadTransport } from '@magic-sdk/provider';
var WebTransport = /** @class */ (function (_super) {
    __extends(WebTransport, _super);
    function WebTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Initialize the underlying `Window.onmessage` event listener.
     */
    WebTransport.prototype.init = function () {
        var _this = this;
        window.addEventListener('message', function (event) {
            var e_1, _a;
            var _b;
            if (event.origin === _this.endpoint) {
                if (event.data && event.data.msgType && _this.messageHandlers.size) {
                    // If the response object is undefined, we ensure it's at least an
                    // empty object before passing to the event listener.
                    /* eslint-disable-next-line no-param-reassign */
                    event.data.response = (_b = event.data.response) !== null && _b !== void 0 ? _b : {};
                    try {
                        for (var _c = __values(_this.messageHandlers.values()), _d = _c.next(); !_d.done; _d = _c.next()) {
                            var handler = _d.value;
                            handler(event);
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                }
            }
        });
    };
    return WebTransport;
}(PayloadTransport));
export { WebTransport };
//# sourceMappingURL=web-transport.js.map